import CIMSTextArea from 'components/CIMSTextArea'
import ArraySelect from './components/ArraySelect'
import PayItemsSelect from './components/PayItemsSelect'
import SelectedBySelect from './components/SelectedBySelect'
import type { FieldControlProps } from './types'

/** Chooses the configured field control while preserving its stored value shape. */
function FieldControl({
  accessibility,
  disabled,
  field,
  onBlur,
  onChange,
  payItems,
  value,
}: FieldControlProps) {
  if (field.type === 'long_text' || field.type === 'comments')
    return (
      <CIMSTextArea
        {...accessibility}
        disabled={disabled}
        onBlur={onBlur}
        onChange={(event) => onChange(event.target.value)}
        value={typeof value === 'string' ? value : ''}
      />
    )
  if (field.type === 'pay_items')
    return (
      <PayItemsSelect
        accessibility={accessibility}
        disabled={disabled}
        field={field}
        onBlur={onBlur}
        onChange={onChange}
        payItems={payItems}
        value={value}
      />
    )
  if (field.type === 'selected_by')
    return (
      <SelectedBySelect
        accessibility={accessibility}
        disabled={disabled}
        field={field}
        onBlur={onBlur}
        onChange={onChange}
        value={value}
      />
    )
  return (
    <ArraySelect
      accessibility={accessibility}
      disabled={disabled}
      field={field}
      onBlur={onBlur}
      onChange={onChange}
      value={value}
    />
  )
}

export default FieldControl
